import { render, staticRenderFns } from "./PresentationWatchPopout.vue?vue&type=template&id=03b0cb5d&scoped=true&"
import script from "./PresentationWatchPopout.vue?vue&type=script&lang=js&"
export * from "./PresentationWatchPopout.vue?vue&type=script&lang=js&"
import style0 from "./PresentationWatchPopout.vue?vue&type=style&index=0&id=03b0cb5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b0cb5d",
  null
  
)

export default component.exports